import { KitStatuses, } from '@repo/types';
export function kitStatusParser(status) {
    if (!status)
        return 'Processing';
    switch (status) {
        case 'expert_review_complete':
        case 'results_ready':
            return 'Results ready';
        case 'activated':
            return 'Activated';
        case 'confirm_kit_returned_to_lab_by_customer':
        case 'delivered_to_customer':
        case 'initialized':
        case 'in_transit_to_customer':
        case 'in_transit_to_lab':
        case 'label_expiry_email_sent':
            return 'Not yet received';
        case 'void_customer_refund':
        case 'void_internal':
        case 'void_lab_error':
        case 'void_lost_in_mail':
        case 'void_return_label_expired':
        case 'void_sample_expired':
        case 'void_shippo_shipment_failed':
        case 'void':
            return 'Void';
        case 'delivered_to_lab':
        case 'sequences_delivered':
        case 'pipeline_complete':
        default:
            return 'Processing';
    }
}
export function parseKitStatus(data) {
    const { status, date_results_ready, date_results_ready_practitioner, date_delivered_to_lab, date_in_transit_to_lab, date_delivered_to_customer, date_activated, date_preparing_shipment, date_in_transit_to_customer, date_waiting_for_payment, date_voided, date_purchased, } = data;
    // Handle void statuses first
    const baseStatus = kitStatusParser(status);
    let defaultDisplayStatus = {
        title: baseStatus,
        color: 'yellow',
    };
    if (baseStatus === 'Void' || date_voided) {
        return {
            title: 'Void',
            color: 'red',
        };
    }
    if (date_results_ready) {
        return {
            title: 'Ready',
            color: 'green',
        };
    }
    if (date_results_ready_practitioner) {
        return {
            title: 'Practitioner review',
            color: 'red',
        };
    }
    if (date_delivered_to_lab) {
        return {
            title: 'Lab',
            color: 'blue',
        };
    }
    if (date_in_transit_to_lab) {
        return {
            title: 'In Transit to Lab',
            color: 'orange',
        };
    }
    if (date_activated) {
        return {
            title: 'Activated',
            color: 'purple',
        };
    }
    if (date_delivered_to_customer) {
        return {
            title: 'Delivered',
            color: 'purple',
        };
    }
    if (date_in_transit_to_customer) {
        return {
            title: 'In Transit to Customer',
            color: 'orange',
        };
    }
    if (date_preparing_shipment) {
        return {
            title: 'Preparing Shipment',
            color: 'blue',
        };
    }
    if (date_purchased) {
        return {
            title: 'Ordered',
            color: 'purple',
        };
    }
    if (date_waiting_for_payment) {
        return {
            title: 'Awaiting Payment',
            color: 'grey',
        };
    }
    return defaultDisplayStatus;
}
const sampleDateComparator = (a, b) => {
    if (!a.sample_date && b.sample_date) {
        return 1;
    }
    else if (a.sample_date && !b.sample_date) {
        return -1;
    }
    else if (a.sample_date && b.sample_date) {
        return (new Date(b.sample_date).getTime() - new Date(a.sample_date).getTime());
    }
    else {
        return 0;
    }
};
export function kitResultsViewable(kit, impersonating = false) {
    if (!kit)
        return false;
    const status = kit.status;
    const date_results_ready = kit.date_results_ready;
    if (date_results_ready)
        return true;
    if (!status)
        return false;
    if (impersonating) {
        return [
            KitStatuses.RESULTS_READY_PRACTITIONER,
            KitStatuses.RESULTS_READY,
            KitStatuses.EXPERT_REVIEW_COMPLETE,
        ].includes(status);
    }
    return [
        KitStatuses.RESULTS_READY,
        KitStatuses.EXPERT_REVIEW_COMPLETE,
    ].includes(status);
}
export const sortKitsByResultsViewableOrLatest = (kits) => {
    if (!kits?.length)
        return [];
    return kits
        .filter(kit => kitStatusParser(kit.status) !== 'Void')
        .sort((a, b) => {
        // first sort by status "results_ready"
        if (kitResultsViewable(a) && !kitResultsViewable(b)) {
            return -1;
        }
        else if (!kitResultsViewable(a) && kitResultsViewable(b)) {
            return 1;
        }
        else {
            return sampleDateComparator(a, b);
        }
    });
};
export function sortKitsByLatestSampleDate(kits) {
    if (!kits?.length)
        return [];
    if (kits.length === 1)
        return kits;
    return kits.sort(sampleDateComparator) || [];
}
export function kitStatusColorParser(status) {
    if (!status)
        return 'default';
    switch (status) {
        case KitStatuses.EXPERT_REVIEW_COMPLETE:
        case KitStatuses.RESULTS_READY:
            return 'good';
        case KitStatuses.DELIVERED_TO_LAB:
        case KitStatuses.PIPELINE_COMPLETE:
        case KitStatuses.SEQUENCES_DELIVERED:
            return 'ok';
        case KitStatuses.VOID_CUSTOMER_REFUND:
        case KitStatuses.VOID_INTERNAL:
        case KitStatuses.VOID_LAB_ERROR:
        case KitStatuses.VOID_LOST_IN_MAIL:
        case KitStatuses.VOID_RETURN_LABEL_EXPIRED:
        case KitStatuses.VOID_SAMPLE_EXPIRED:
        case KitStatuses.VOID_SHIPPO_SHIPMENT_FAILED:
        case KitStatuses.RETURN_MISSING:
            return 'bad';
        case KitStatuses.ACTIVATED:
        case KitStatuses.CONFIRM_KIT_RETURNED_TO_LAB_BY_CUSTOMER:
        case KitStatuses.DELIVERED_TO_CUSTOMER:
        case KitStatuses.INITIALIZED:
        case KitStatuses.IN_TRANSIT_TO_CUSTOMER:
        case KitStatuses.IN_TRANSIT_TO_LAB:
        case KitStatuses.LABEL_EXPIRY_EMAIL_SENT:
        default:
            return 'default';
    }
}
//# sourceMappingURL=kitStatus.js.map